export default "__VITE_ASSET__CxtUy_3b__"